'use strict';exports.__esModule = true;exports.discountCouponsTypes = exports.couponCodes = exports.couponsTypes = undefined;var _value, _value2, _discountCouponsTypes; /* eslint-disable quote-props */
var _packagesData = require('../../packagesData');

var couponsTypes = exports.couponsTypes = {
  DISCOUNT: 'discountFromPrice',
  FREE: 'freeMonth' };


var codes = {
  FREE_MONTH: 'FREEMONTH',
  TWO_FREE_MONTH: '2FREEMONTH',
  DISCOUNT_THIRTY: '30%OFF',
  DISCOUNT_TWENTY_FIVE: '25%OFF',
  DISCOUNT_FRIENDS: 'חברים',
  DISCOUNT_PROMO: '0720' };


var couponCodes = exports.couponCodes = {
  realtor: [
  codes.FREE_MONTH,
  codes.TWO_FREE_MONTH,
  codes.DISCOUNT_THIRTY,
  codes.DISCOUNT_FRIENDS,
  codes.DISCOUNT_PROMO],

  regular: [codes.DISCOUNT_TWENTY_FIVE] };


var discountCouponsTypes = exports.discountCouponsTypes = (_discountCouponsTypes = {}, _discountCouponsTypes[
codes.FREE_MONTH] = {
  type: couponsTypes.FREE,
  value: 1 }, _discountCouponsTypes[

codes.TWO_FREE_MONTH] = {
  type: couponsTypes.FREE,
  value: 2 }, _discountCouponsTypes[

codes.DISCOUNT_TWENTY_FIVE] = {
  type: couponsTypes.DISCOUNT,
  value: 25 }, _discountCouponsTypes[

codes.DISCOUNT_THIRTY] = {
  type: couponsTypes.DISCOUNT,
  value: 30 }, _discountCouponsTypes[

codes.DISCOUNT_FRIENDS] = {
  type: couponsTypes.DISCOUNT,
  value: (_value = {}, _value['package_id_1_' +
  _packagesData.periods.TWELVE_MONTHS] = 0, _value['package_id_2_' +
  _packagesData.periods.TWELVE_MONTHS] = 10, _value['package_id_3_' +
  _packagesData.periods.TWELVE_MONTHS] = 15, _value['package_id_4_' +
  _packagesData.periods.TWELVE_MONTHS] = 20, _value) }, _discountCouponsTypes[


codes.DISCOUNT_PROMO] = {
  type: couponsTypes.DISCOUNT,
  value: (_value2 = {}, _value2['package_id_1_' +
  _packagesData.periods.TWELVE_MONTHS] = 0, _value2['package_id_2_' +
  _packagesData.periods.TWELVE_MONTHS] = 10, _value2['package_id_3_' +
  _packagesData.periods.TWELVE_MONTHS] = 15, _value2['package_id_4_' +
  _packagesData.periods.TWELVE_MONTHS] = 20, _value2) }, _discountCouponsTypes);


//////////////////
// WEBPACK FOOTER
// ./src/containers/DiscountCouponContainer/couponsConfig.js
// module id = 385
// module chunks = 0